export default __webpack_public_path__ + "static/media/logo-regal.d13c09e3.png";